/* eslint-disable */
import * as types from './types';
import router from "../../../router";
import axios from 'axios';

const actions = {
  login({commit}){
    // run login process here
  },
  handleConsoleAuthentication({commit}, [token]){
    if( token == undefined ){
      router.push('/auth/loginerror');
    }
    axios.post(process.env.API_ENDPOINT + 'sso/verifytoken', {
      token: token
    })
    .then(function (response) {
      console.log(response.data);
      commit('login', response.data);
      router.push('/dashboard');
    })
    .catch(function (error) {
      router.push('/auth/loginerror');
    });

  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js